export default __webpack_public_path__ + "static/media/CoffeeBeans.efc5e713.svg";